(function () {
  var VIDEO_ID = 'kHlmfGp7XRs';
  var player, q25=false, q50=false, q95=false, played=false, intervalId=null;

  // Only run on pages that actually have this YouTube embed
  function pageHasVideo(){
    return !!document.querySelector('iframe[src*="youtube.com/embed/"][src*="'+VIDEO_ID+'"]');
  }

  function whenFbqReady(cb){
    if (typeof fbq === 'function') return cb();
    setTimeout(function(){ whenFbqReady(cb); }, 200);
  }

  function prepareIframe(){
    var iframe = document.querySelector('iframe[src*="youtube.com/embed/"][src*="'+VIDEO_ID+'"]');
    if (!iframe) return null;
    if (!iframe.id) iframe.id = 'newLowsPlayer';

    try {
      var url = new URL(iframe.src, location.origin);
      var qs = url.searchParams;
      if (!qs.has('enablejsapi')) qs.set('enablejsapi','1');
      if (!qs.has('playsinline')) qs.set('playsinline','1');
      if (!qs.has('rel')) qs.set('rel','0');
      if (!qs.has('modestbranding')) qs.set('modestbranding','1');
      url.search = qs.toString();
      if (iframe.src !== url.toString()) iframe.src = url.toString();
    } catch(e) {}
    return iframe.id;
  }

  function loadYTApi(){
    if (window.YT && window.YT.Player) return Promise.resolve();
    return new Promise(function(resolve){
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function(){
        if (typeof prev === 'function') try { prev(); } catch(e){}
        resolve();
      };
    });
  }

  function startProgressWatcher(){
    if (intervalId) return;
    intervalId = setInterval(function(){
      try {
        var d = player.getDuration() || 0;
        var t = player.getCurrentTime ? player.getCurrentTime() : 0;
        if (!d) return;
        var p = t/d;
        whenFbqReady(function(){
          if (p >= 0.25 && !q25){ q25 = true; fbq('trackCustom','YouTube25',{videoId: VIDEO_ID}); }
          if (p >= 0.50 && !q50){ q50 = true; fbq('trackCustom','YouTube50',{videoId: VIDEO_ID}); }
          if (p >= 0.95 && !q95){ q95 = true; fbq('trackCustom','YouTube95',{videoId: VIDEO_ID}); }
        });
      } catch(e){}
    }, 1000);
  }

  function init(){
    var id = prepareIframe();
    if (!id) return;
    loadYTApi().then(function(){
      player = new YT.Player(id, {
        events: {
          onStateChange: function(e){
            if (e.data === YT.PlayerState.PLAYING) {
              if (!played){
                played = true;
                whenFbqReady(function(){ fbq('trackCustom','YouTubePlay',{videoId: VIDEO_ID}); });
              }
              startProgressWatcher();
            }
          }
        }
      });
    });
  }

  // Run once DOM is ready and only if the video exists on this page (album page or homepage)
  document.addEventListener('DOMContentLoaded', function(){
    if (!pageHasVideo()) return;
    init();

    // Track outbound clicks to YouTube for this video
    document.addEventListener('click', function(e){
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if ((/youtu\.be\/|youtube\.com\/watch/.test(href)) && href.indexOf(VIDEO_ID)!==-1) {
        whenFbqReady(function(){ fbq('trackCustom','YouTubeOutboundClick',{videoId: VIDEO_ID}); });
      }
    }, true);
  });
})();